import React from 'react';
import TextField from '@mui/material/TextField';
import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { validateAmount } from './OrderTargetMarginHelper';

export default function TargetMarginAmountCell(params: GridRenderEditCellParams) {
  const { id, field, value: initialValue, api } = params;
  const [value, setValue] = React.useState(String(initialValue));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (newValue === '' || validateAmount(newValue)) {
      setValue(newValue);
      api.setEditCellValue({ id, field, value: newValue }, event);
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = event.clipboardData.getData('text');
    if (!validateAmount(pasted)) {
      event.preventDefault();
    }
  };

  return (
    <TextField
      value={value}
      type="text"
      fullWidth
      inputProps={{ inputMode: 'decimal' }}
      onChange={handleChange}
      onPaste={handlePaste}
    />
  );
}
